import { h, Fragment } from 'preact';
import PropTypes from 'prop-types';

import SkyItTabsButton from './sky-it-tabs-button';

/*
Usage

<SkyItTabs selectedTab={1} onTabClick={() => {}}>
  <SkyItTab key={0} title="First tab" icon={<IconEdit modifiers={['c-light', 'xsmall', 'edit']} />}>
    <div>Tab 1 content</div>
  </SkyItTab>
  <SkyItTab key={1} title="First tab" icon={<IconEdit modifiers={['c-light', 'xsmall', 'edit']} />}>
    <div>Tab 2 content</div>
  </SkyItTab>
</SkyItTabs>
*/

const CONTENT_WRAPPER_CLASSNAME = 's-sky-it-tab-content-wrapper';

const SkyItTabs = ({ children, selectedTab = 1, onTabClick }) => (
  <Fragment>
    <div className="c-sky-it-tabs">
      {children.map((item, index) => (
        <SkyItTabsButton
          key={index}
          index={index}
          title={item.props.title}
          icon={item.props.icon}
          onClick={onTabClick}
          active={index === selectedTab}
        />
      ))}
    </div>
    {children.map((item, index) => (
      <div key={index} className={`${CONTENT_WRAPPER_CLASSNAME} ${index === selectedTab ? '' : 'is-hidden'}`}>
        {item}
      </div>
    ))}
  </Fragment>
);

SkyItTabs.propTypes = {
  children: PropTypes.any,
  selectedTab: PropTypes.number,
  onTabClick: PropTypes.func,
};

export default SkyItTabs;
